<template>
  <div class="reform">
    <div class="userInfor">
      <span>个人信息</span>
      <div class="btn">
        <el-button size="small" type="success" style="margin-top: 12px" :disabled="disabled"
          @click.native="save('ruleForm')">保存</el-button>
        <el-button size="small" type="warning" style="margin-top: 12px" :disabled="disabled"
          @click.native="next('ruleForm')">下一步</el-button>
      </div>
    </div>
    <el-form ref="ruleForm" :model="ruleForm" align="left" :rules="rules" class="eg_form">
      <el-row :gutter="20" v-if="isFlag == 1">
        <el-col :span="12">
          <el-form-item label="所属类型：" prop="userType" :label-width="formLabelWidth">
            <el-radio-group v-model="ruleForm.userType">
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="有审核员背景且目前不从事专利审查工作的非在职人员"
                placement="top-start"
              > -->
              <el-radio label="1" @change="reviewer($event)">代理人背景</el-radio>
              <!-- </el-tooltip> -->

              <el-radio label="2" @change="reviewer($event)">审查员背景
                <el-tooltip class="item" effect="dark" content="有审查员背景且目前不从事专利审查工作的在职人员" placement="top-start">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名：" prop="userName" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.userName" placeholder="请输入姓名" @input="change($event)"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="性别：" prop="sex" :label-width="formLabelWidth">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><el-form-item label="证件类型：" prop="idcardType" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.idcardType" placeholder="请选择证件类型" @change="getLastChangeIndex($event)">
              <el-option v-for="(item, index) in idCardList" :key="index" :label="item.value"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="证件号码：" prop="idcardNum" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.idcardNum" type="text" auto-complete="off" placeholder="请输入证件号"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12" v-else>
          <el-form-item
            label="证件号码1："
            prop="idcardNums"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="ruleForm.idcardNums"
              type="text"
              auto-complete="off"
              placeholder="请输入证件号"
              @focus="accountFn"
            ></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><el-form-item label="联系手机：" prop="mobilePhone" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.mobilePhone" placeholder="请输入手机号"></el-input> </el-form-item></el-col>

        <el-col :span="12">
          <el-form-item label="电子邮箱：" prop="email" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系地址：" required :label-width="formLabelWidth">
            <div class="seleCity">
              <el-form-item prop="province"><el-select v-model="ruleForm.province" placeholder="省" value-key="area_code"
                  @change="getEonomize($event)">
                  <el-option v-for="(item, index) in eonomizeList" :key="index" :label="item.area_name"
                    :value="item"></el-option> </el-select></el-form-item>

              <el-form-item prop="city"><el-select v-model="ruleForm.city" placeholder="市" value-key="area_code"
                  @change="getMarket($event)">
                  <el-option v-for="(item, index) in marketList" :key="index" :label="item.area_name"
                    :value="item"></el-option> </el-select></el-form-item>

              <el-form-item prop="county">
                <el-select v-model="ruleForm.county" placeholder="区/县" value-key="area_code"
                  @change="getCounty($event)">
                  <el-option v-for="(item, index) in countyList" :key="index" :label="item.area_name"
                    :value="item"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item prop="address" style="width: 100%">
              <el-input v-model="ruleForm.address" type="text" placeholder="请输入单位地址"></el-input>
            </el-form-item>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="上传照片：" :label-width="formLabelWidth" prop="imageUrl">
            <el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove" :http-request="submitUpload" :on-success="imgSuccess"
              :before-upload="beforeAvatarUpload" :limit="1" :multiple="false" :file-list="fileList"
              accept=".png,.jpg,.jpeg,.bmp" :on-exceed="handleExceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div>请上传2MB以内个人1寸照片</div>
            <el-dialog :visible.sync="dialogVisible">
              <!-- <img width="100%" :src="dialogImageUrl" alt="" /> -->
              <img width="100%" :src="ruleForm.imageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  checkRepeat,
  getAreaList,
  getDictInfoNew,
  aptitudeDetail,
  userInfo,

} from "@/api/api.js";
export default {
  name: "",
  components: {},
  props: {
    // region:{
    //   type: String, //指定值类型
    //   required: true, //是否为必传项
    // }
    isFlag: String,
    // infoMation: Object,
    activeNum: Number,
    // idsession: String
  },
  data() {
    // 验证手机号
    var checkphone = (rule, value, callback) => {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!this.isCellPhone(value)) {
        // 引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));
        let parames = {
          value: this.ruleForm.mobilePhone, //enterprise_name：企业名称  credit_code：统一社会信用代码  account：登录账号
          type: 2,
        };
        // console.log("5555", this.idcardNum);
        checkRepeat(parames).then((res) => {
          if (res.code == "1000") {
            if (!res.data) {
              return callback(new Error("手机号已存在")); //false 为已绑定 true 为未绑定校验通过
            } else {
              callback();
            }
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };
    
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      } else {
        const reg =
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        if (!reg.test(value)) {
          const msg = rule.msg ? rule.msg : "邮箱格式不正确";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };

    return {
      ruleForm: {
        imageUrl: "",
        userName: "",
        userType: "1",
        province: "", //省
        provinceCode: "",
        city: "", //市
        cityCode: "", //市代码
        countyCode: "", //区县代码
        county: "", //区县
        sex: "",
        address: "",
        idcardType: "",
        idcardNum: "",
        mobilePhone: "",
        email: "",
        annexFile: "",
      },
      disabled: false,
      eonomizeList: [], //省
      marketList: [], //市
      countyList: [],
      sexList: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
      idCardList: [],
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: ["change", "blur"] },
          {
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: ["blur", "change"],
          },
        ],
        userType: [
          { required: true, message: "请选择所属类型", trigger: "change" },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["change", "blur"],
          },
        ],
        idcardType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        idcardNum: [
          { required: true, message: "证件号不能为空", trigger: "blur" },
          // { validator: checkIdcard, trigger: "blur" },
          {
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: ["blur", "change"],
          },
        ],
        mobilePhone: [
          {
            required: true,
            validator: checkphone,
            trigger: ["blur"],
          },
          // { validator: checkMobile, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: ["blur"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: ["blur", "change"],
          },
          {
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: ["blur", "change"],
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: ["blur", "change"],
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: ["blur", "change"],
          },
        ],
        county: [
          {
            required: true,
            message: "请选择区/县",
            trigger: ["blur", "change"],
          },
        ],
        // imageUrl: [
        //   {
        //     required: true,
        //     message: "请上传图片",
        //     trigger: ["change", "blur"],
        //   },
        // ],
      },
      formLabelWidth: "120px",
      dialogImageUrl: "",
      dialogVisible: false,
      active: "",
      fileList: [],
      userInfoid: this.$route.query.userInfos,
      infoMation: {},
    };
  },
  computed: {},
  watch: {
    activeNum(val) {
      if (this.userInfoid == null) {
        this.userInfoid = sessionStorage.getItem('userInfoid')
      }
      if (val == 1) {
        if (this.userInfoid) {
          this.getDetail();
        } else {
          this.getInfo();
        }
      }
    },
  },
  async created() {
    await getDictInfoNew("ZJLX").then((res) => {
      this.idCardList = res.data;
    });
  },
  mounted() {
    this.getArea(1, "");
    if (this.userInfoid) {
      this.getDetail();
    } else {
      this.getInfo();
    }
  },
  methods: {
    change(e) {
      this.$forceUpdate()
    },
    getInfo() {
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        userInfo({ id: user.id }).then((res) => {
          this.infoMation = res.data;
          this.sexList.map((item) => {
            if (item.label == this.infoMation.sex) {
              this.infoMation.sex = item.value.toString();
            }
          });
          this.idCardList.map((item) => {
            if (item.value == this.infoMation.idcardType) {
              this.infoMation.idcardType = item.code;
            }
          });
          this.fileList = []
          this.infoMation.userName = this.infoMation.examUserName
          this.ruleForm = this.infoMation;
        });
      }

    },
    getDetail() {
      aptitudeDetail(
        this.$qs.stringify({ id: this.userInfoid })
      ).then((res) => {
        if (res.code == "1000") {
          let baseUrl = window.global_config.BASE_URL;
          let url = `${baseUrl}/v1/api/file/${res.data.photos.id}/view`;
          let a = { url: url };
          this.fileList = []
          this.fileList.push(a);
          this.ruleForm = res.data;
          this.ruleForm.imageUrl = url;
          // this.ruleForm.annexFile = url;
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type == "image/bmp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传照片格式只能是jpg、png、jpeg、bmp。");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      if (file.name.length > 50) {
        this.$message.error("文件名称不能超过50位");
        return false;
      }
      return isJPG && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    provinceId(val) {
      console.log("省", val);
    },
    reviewer(val) {
      // console.log("所属类型", val);
      this.ruleForm.userType = val;
      // sessionStorage.removeItem("region");
      this.$store.state.region = val;
      sessionStorage.setItem("region", val);
    },
    submitUpload(file) {
      // this.$refs.ruleForm.clearValidate("imageUrl");
      // this.$refs.ruleForm.clearValidate();
      this.ruleForm.imageUrl = URL.createObjectURL(file.file);
      this.ruleForm.annexFile = file.file;

      // this.fileList = []
      // this.fileList.push(file.file);

    },
    accountFn() {
      console.log("获取焦点");
    },
    //验证手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    // 获取省
    getEonomize(val) {
      // console.log("获取省", val);
      this.getArea(2, val.area_code);
      this.ruleForm.provinceCode = val.area_code;
      this.ruleForm.province = val.area_name;
      this.ruleForm.cityCode = "";
      this.ruleForm.city = "";
      this.ruleForm.countyCode = "";
      this.ruleForm.county = "";
    },
    // 获取市
    getMarket(val) {
      // console.log("获取市", val);
      this.getArea(3, val.area_code);
      this.ruleForm.cityCode = val.area_code;
      this.ruleForm.city = val.area_name;
      this.ruleForm.countyCode = "";
      this.ruleForm.county = "";
    },
    // 获取县区
    getCounty(val) {
      // console.log("获取县区", val);
      this.ruleForm.countyCode = val.area_code;
      this.ruleForm.county = val.area_name;
    },
    getArea(type, idCode) {
      let params = {
        level: type,
        parentCode: idCode,
      };
      getAreaList(params).then((res) => {
        if (res.code == "1000") {
          if (type == "1") {
            this.eonomizeList = res.data;
          } else if (type == "2") {
            this.marketList = res.data;
            // this.idCode = this.ruleForm.provinceCode;
          } else {
            this.countyList = res.data;
            // this.cityCode = this.ruleForm.cityCode;
          }
        }
      });
    },
    getLastChangeIndex(val) {
      this.ruleForm.idcardType = val;
    },
    handleRemove(file, fileList) {
      this.ruleForm.annexFile = "";
      this.ruleForm.imageUrl = "";
    },
    imgSuccess(res, file, fileList) {
      console.log("lalal", fileList);
    },
    handlePictureCardPreview(file) {
      // console.log("file0000000000000", file);
      // this.dialogImageUrl = file.url;
      this.ruleForm.imageUrl = file.url;
      this.dialogVisible = true;
    },
    save(ruleForm) {
      if (this.ruleForm.idcardType == "1") {
        const reg =
          /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!reg.test(this.ruleForm.idcardNum)) {
          this.$message.error("身份证格式不正确");
          return;
        }
      }
      this.$refs[ruleForm].validate((valid) => {
        // console.log(valid);
        if (valid) {
          if (!this.ruleForm.imageUrl) {
            this.$message.error("请上传照片");
            return false;
          }
          let form = this.ruleForm;
          this.active = 1;
          // this.$emit("next", this.active, form, "", 1);
          this.$parent.next(1, form, "", 1).then(res => {
            if (res) {
              if(this.userInfoid == null){
                this.userInfoid = res.data.id
              }
              this.getDetail()
            }
          })
        } else {
          console.log("error submit!!");
          // return false;
        }
      });
    },
    next(ruleForm) {
      // console.log("formName", this.ruleForm);
      if (this.ruleForm.idcardType == "1") {
        const reg =
          /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!reg.test(this.ruleForm.idcardNum)) {
          this.$message.error("身份证格式不正确");
          return;
        }
      }
      this.$refs[ruleForm].validate((valid) => {
        // console.log(valid);
        if (valid) {
          if (!this.ruleForm.imageUrl) {
            this.$message.error("请上传照片");
            return false;
          }
          let form = this.ruleForm;
          this.active = 1;
          // this.$emit("next", this.active, form, "", 2);
          this.$parent.next(1, form, "", 2).then(res => {
            if (res) {
              console.log(res,'$parent')
              if(this.userInfoid == null){
                this.userInfoid = res.data.id
              }
              this.getDetail()
            }
          })
        } else {
          console.log("error submit!!");
          // return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.userInfor {
  margin: 30px 60px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  font-size: 15px;

  // .btn {
  //   display: flex;
  //   justify-content: center;
  //   align-items: flex-end;
  // }
}

// ::v-deep.el-form-item__content {
//   text-align: left;
// }
.eg_form {
  margin: 10px 80px;
}

.seleCity {
  width: 100%;
  display: flex;
  margin-bottom: 22px;
  justify-content: space-between;

  ::v-deep .el-form-item {
    width: 100% !important;
  }

  ::v-deep .el-select {
    width: 98%;

    ::v-deep .el-input {
      width: 100% !important;
    }
  }
}

::v-deep .el-select {
  width: 100%;
  // text-align: left;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;

  img {
    width: 100%;
    height: 100%;
  }
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}

::v-deep .avatar-uploader-icon {
  width: 70px;
  height: 80px;
  line-height: 80px;
}

.avatar-uploader {
  float: left;
  width: 100px;
  height: 100px;
  line-height: 100px;
}

// .avatar-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 178px;
//   height: 178px;
//   line-height: 178px;
//   text-align: center;
// }
// .avatar {
//   width: 178px;
//   height: 178px;
//   display: block;
// }
.addressSele {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .el-select {
    width: 32%;
  }
}

::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 110px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 110px;
}

.item {
  margin: 4px;
}
</style>